import { render, staticRenderFns } from "./recordReportV1.vue?vue&type=template&id=4250c181&"
import script from "./recordReportV1.vue?vue&type=script&lang=js&"
export * from "./recordReportV1.vue?vue&type=script&lang=js&"
import style0 from "./recordReportV1.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports